import { Component, OnInit } from '@angular/core';
import { DataService } from "../services/dataservice.service";
import { FileService } from "../services/fileservice.service";
import { FileModel } from "../services/file.model";

@Component({
  selector: 'app-downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.css']
})
export class DownloadsComponent implements OnInit {

  private intro: string = '';
  public files:FileModel[] = [];

  constructor(private dataService: DataService, private fileService: FileService) {

    this.dataService.dataServiceArrived.subscribe(
      (data) =>
      {
        this.intro = data.filter((data) => {return data.Type == 'intro-downloads'})[0].Content;
      }
    );
    this.fileService.fileListUpdated.subscribe(
      (files: FileModel[]) => {
        this.files = files;
      }
    )
  }

  ngOnInit() {
    this.dataService.getContent();
    this.fileService.getFileList();
  }

}



// WEBPACK FOOTER //
// ./src/app/main/downloads/downloads.component.ts